export default __webpack_public_path__ + "static/about-us-security--mobile-3530d9bec989ec7b518a978b9930e3fa.webp";